"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EotcChartAPI = _interopRequireDefault(require("../../services/tradingView/EotcChartAPI"));
var _jstimezonedetect = _interopRequireDefault(require("jstimezonedetect"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
var _path = _interopRequireDefault(require("../../helpers/path"));
var _config = _interopRequireDefault(require("../../config"));
var _wsHelper = require("../../helpers/wsHelper");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _withCssVars = require("../Theme/withCssVars");
require("./EotcPriceChart.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* global TradingView */
var chartClasses = (0, _cssClassesHelper.getBEMClasses)(['eotc-price-chart']);

/**
 * These items were either non-working or buggy within our TradingView implementation,
 *  and should stay disabled until they are fixed or reassessed.
 */

var disabledFeatures = ['header_settings', 'control_bar', 'context_menus', 'header_symbol_search', 'header_compare', 'use_localstorage_for_settings', 'save_chart_properties_to_local_storage', 'show_chart_property_page', 'header_resolutions', 'go_to_date'];
var EotcPriceChartComponent = /*#__PURE__*/function (_React$Component) {
  function EotcPriceChartComponent() {
    var _this;
    _classCallCheck(this, EotcPriceChartComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EotcPriceChartComponent, [].concat(args));
    _defineProperty(_this, "state", {
      chartInitialized: false
    });
    _defineProperty(_this, "script", function (location) {
      return new Promise(function (resolve) {
        _this.scripts[location] = document.createElement('script');
        _this.scripts[location].src = (0, _path["default"])(location);
        _this.scripts[location].type = 'text/javascript';
        _this.scripts[location].async = true;
        _this.scripts[location].onload = resolve;
        document.body.appendChild(_this.scripts[location]);
      });
    });
    _defineProperty(_this, "createChart", function (dataFeed) {
      var _this$getOverrides = _this.getOverrides(),
        overrides = _this$getOverrides.overrides,
        studiesOverrides = _this$getOverrides.studiesOverrides;
      var custom_css_url = _this.props.theme === 'light' ? '' : '/vendor/tradingView/charting_library-dark-theme.css';
      var chartOptions = {
        symbol: _this.props.selectedInstrument.Symbol,
        datafeed: dataFeed,
        library_path: (0, _path["default"])('/vendor/tradingView/'),
        autosize: true,
        interval: '60',
        container_id: 'trading-view-chart',
        loading_screen: {
          backgroundColor: _this.props.getCssVar('eotc-price-chart__bg-color')
        },
        custom_css_url: (0, _path["default"])(custom_css_url),
        supportedResolutions: ['1S', '1', '5', '60', '1D', '1W', '1M', '12M'],
        time_frames: [{
          text: '1m',
          resolution: '1'
        }, {
          text: '1h',
          resolution: '60'
        }, {
          text: '1d',
          resolution: '1D'
        }, {
          text: '1w',
          resolution: '1W'
        }, {
          text: '1mo',
          resolution: '1M'
        }, {
          text: '1y',
          resolution: '12M'
        }],
        overrides: overrides,
        studies_overrides: studiesOverrides
      };
      var localOverrides = _config["default"].TradingView || {};
      var disabled_features;
      if ('disabled_features' in localOverrides) {
        disabled_features = _toConsumableArray(new Set([].concat(disabledFeatures, _toConsumableArray(localOverrides.disabled_features))));
      } else {
        disabled_features = disabledFeatures;
      }
      var enabled_features = [];
      if ('enabled_features' in localOverrides) {
        enabled_features = localOverrides.enabled_features.filter(function (item) {
          return !disabledFeatures.includes(item);
        });
      }

      // For some reasons TradingView.onready is not fired, timeout is used as fallback to initialize chart after 1.5 sec
      _this.timeout = setTimeout(function () {
        if (!window.TradingView) return;
        _this.chart = new TradingView.widget(_objectSpread(_objectSpread(_objectSpread({}, chartOptions), localOverrides), {}, {
          disabled_features: disabled_features,
          enabled_features: enabled_features
        }));
        _this.chart.onChartReady(function () {
          _this.setState({
            chartInitialized: true
          });
          _this.chart.chart().setChartType(2);
        });
      }, 1500);
    });
    return _this;
  }
  _inherits(EotcPriceChartComponent, _React$Component);
  return _createClass(EotcPriceChartComponent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (!!window.TradingView && this.props.selectedInstrument.InstrumentId !== nextProps.selectedInstrument.InstrumentId) {
        window.tvChartDataFeed = null;
        return true;
      }
      return !!window.TradingView && !!nextState && !!nextState.chartInitialized;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.chartInitialized && this.chart) {
        this.chart.chart().setSymbol(this.props.selectedInstrument.Symbol);
        if (prevProps.theme !== this.props.theme) {
          var _this$getOverrides2 = this.getOverrides(),
            overrides = _this$getOverrides2.overrides,
            studiesOverrides = _this$getOverrides2.studiesOverrides;
          this.chart.changeTheme(this.props.theme);
          this.chart.applyOverrides(overrides);
          this.chart.applyStudiesOverrides(studiesOverrides);
          if (this.props.theme === 'dark') {
            this.chart.addCustomCSSFile('/vendor/tradingView/charting_library-dark-theme.css');
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.scripts = {};
      this.script('/vendor/jquery-3.3.1.min.js').then(function () {
        return _this2.script('/vendor/tradingView/charting_library.min.js');
      }).then(function () {
        _this2.initChart();
      });
    }
  }, {
    key: "initChart",
    value: function initChart() {
      if (!this.props.selectedInstrument.InstrumentId) return;
      this.wsUri = (0, _wsHelper.getGateway)();
      var timezone = _jstimezonedetect["default"].determine().name();
      var currentTimezone = timezone ? timezone : _config["default"].TradingView.timezone;
      if (!this.chart) {
        if (!window.tvChartDataFeed) {
          window.tvChartDataFeed = new _EotcChartAPI["default"].UDFCompatibleDatafeed(this.wsUri, null, null, this.props.customGateway, currentTimezone, this.props.decimalPlaces, this.props.instrumentsArray);
        }
        this.createChart(window.tvChartDataFeed);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      if (this.chart) {
        try {
          this.chart.remove();
        } catch (e) {
          console.warn('silently handled chart error: ', e);
        }
        this.scripts['/vendor/tradingView/charting_library.min.js'].remove();
        this.scripts['/vendor/jquery-3.3.1.min.js'].remove();
      }
    }
  }, {
    key: "getOverrides",
    value: function getOverrides() {
      var getCssVar = this.props.getCssVar;
      var bgColor = getCssVar('eotc-price-chart__bg-color');
      var gridColor = getCssVar('eotc-price-chart__border-color');
      var gridColorVertical = getCssVar('eotc-price-chart__border-color');
      var gridColorHorizontal = getCssVar('eotc-price-chart__border-color');
      var scaleFontColor = getCssVar('eotc-price-chart__scale-font-color');
      var scaleLineColor = getCssVar('eotc-price-chart__scale-line-color');
      var scaleBgColor = getCssVar('eotc-price-chart__bg-color');
      var graphUpColor = getCssVar('eotc-price-chart__graph-up-color');
      var graphDownColor = getCssVar('eotc-price-chart__graph-down-color');
      var graphBorderUpColor = getCssVar('tv-chart__graph-border-up-color');
      var graphBorderDownColor = getCssVar('tv-chart__graph-border-down-color');
      var graphUpOpaqueColor = "rgba(".concat(getCssVar('pc__accent-additive'), ", .3)");
      var graphDownOpaqueColor = "rgba(".concat(getCssVar('pc__accent-subtractive'), ", .3)");
      var overrides = {
        'paneProperties.background': bgColor,
        'paneProperties.gridProperties.color': gridColor,
        'paneProperties.vertGridProperties.color': gridColorVertical,
        'paneProperties.horzGridProperties.color': gridColorHorizontal,
        'paneProperties.topMargin': 15,
        'paneProperties.bottomMargin': 25,
        'scalesProperties.textColor': scaleFontColor,
        'scalesProperties.lineColor': scaleLineColor,
        'scalesProperties.showLeftScale': false,
        'scalesProperties.showRightScale': true,
        'scalesProperties.backgroundColor': scaleBgColor,
        volumePaneSize: 'large',
        'mainSeriesProperties.candleStyle.upColor': graphUpColor,
        'mainSeriesProperties.candleStyle.downColor': graphDownColor,
        'mainSeriesProperties.candleStyle.borderUpColor': graphDownColor,
        'mainSeriesProperties.candleStyle.borderDownColor': graphBorderDownColor,
        'mainSeriesProperties.candleStyle.drawWick': true,
        'mainSeriesProperties.hollowCandleStyle.upColor': graphUpColor,
        'mainSeriesProperties.hollowCandleStyle.downColor': bgColor,
        'mainSeriesProperties.hollowCandleStyle.borderUpColor': graphBorderUpColor,
        'mainSeriesProperties.hollowCandleStyle.borderDownColor': graphBorderDownColor,
        'mainSeriesProperties.hollowCandleStyle.drawWick': false,
        'mainSeriesProperties.haStyle.upColor': graphUpColor,
        'mainSeriesProperties.haStyle.downColor': graphDownColor,
        'mainSeriesProperties.haStyle.borderUpColor': graphBorderUpColor,
        'mainSeriesProperties.haStyle.borderDownColor': graphBorderDownColor,
        'mainSeriesProperties.haStyle.drawWick': false,
        'mainSeriesProperties.barStyle.upColor': graphUpColor,
        'mainSeriesProperties.barStyle.downColor': graphDownColor,
        'mainSeriesProperties.lineStyle.color': '#7898C7',
        'mainSeriesProperties.lineStyle.linewidth': '4',
        'mainSeriesProperties.areaStyle.color1': graphUpColor,
        'mainSeriesProperties.areaStyle.color2': graphUpOpaqueColor,
        'mainSeriesProperties.areaStyle.linecolor': graphUpColor,
        'mainSeriesProperties.baselineStyle.topFillColor1': graphUpOpaqueColor,
        'mainSeriesProperties.baselineStyle.topFillColor2': graphUpOpaqueColor,
        'mainSeriesProperties.baselineStyle.bottomFillColor1': graphDownOpaqueColor,
        'mainSeriesProperties.baselineStyle.bottomFillColor2': graphDownOpaqueColor,
        'mainSeriesProperties.baselineStyle.topLineColor': graphUpColor,
        'mainSeriesProperties.baselineStyle.bottomLineColor': graphDownColor
      };
      var studiesOverrides = {
        'volume.volume.color.0': graphDownOpaqueColor,
        'volume.volume.color.1': graphUpOpaqueColor
      };
      return {
        overrides: overrides,
        studiesOverrides: studiesOverrides
      };
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        bidValue = _this$props.bidValue,
        askValue = _this$props.askValue;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: chartClasses('', {
          'with-depth-chart': _config["default"].TradingLayout.showDepthChart
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: chartClasses('header')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: chartClasses('header-title')
      }, t("Price Chart")), /*#__PURE__*/_react["default"].createElement("div", {
        className: chartClasses('header-data')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: chartClasses('bid-value')
      }, t("Bid"), /*#__PURE__*/_react["default"].createElement("span", null, bidValue)), /*#__PURE__*/_react["default"].createElement("div", {
        className: chartClasses('ask-value')
      }, t("Ask"), /*#__PURE__*/_react["default"].createElement("span", null, askValue)))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "trading-view-chart",
        className: chartClasses('chart-container')
      }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)));
    }
  }]);
}(_react["default"].Component);
_defineProperty(EotcPriceChartComponent, "propTypes", {
  selectedInstrument: _propTypes["default"].object,
  getCssVar: _propTypes["default"].func,
  theme: _propTypes["default"].string
});
EotcPriceChartComponent.propTypes = {
  selectedInstrument: _propTypes["default"].object
};
EotcPriceChartComponent.defaultProps = {
  bidValue: 0,
  askValue: 0
};
var _default = exports["default"] = (0, _withCssVars.withCssVars)((0, _reactI18next.withTranslation)('stream')(EotcPriceChartComponent));